export class Plan {
	_id: string;
	descripcion: string;
	historico_dias: number;
	max_nodos: number;
	mkt: boolean;
	alarmas_rango: boolean;
	alarmas_calibracion: boolean;
	alarmas_sin_actividad: boolean;
	alarmas_sin_informacion: boolean;
	alarmas_bateria: boolean;
	menus: string[];
	orden: number;
	estado: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/plan/plan.ts